import React from "react";
import {
  CheckIcon,
  MinusCircleIcon,
  PlusCircleIcon,
} from "@heroicons/react/solid";
import formatDate from "../../../utils/helpers";

const eventTypes = {
  tookLoan: { icon: MinusCircleIcon, bgColorClass: "bg-red-400" },
  paidSettlement: { icon: PlusCircleIcon, bgColorClass: "bg-blue-500" },
  completed: { icon: CheckIcon, bgColorClass: "bg-green-500" },
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Timeline({ agent }) {
  console.log("-------------------------------");
  console.log(agent.attributes.timelines);
  console.log("-------------------------------");

  const timelines = agent.attributes.timelines?.data;

  return (
    <section
      aria-labelledby="timeline-title"
      className="lg:col-start-3 lg:col-span-1"
    >
      <div className="bg-white px-4 py-5 shadow sm:rounded-lg sm:px-6">
        <h2 id="timeline-title" className="text-lg font-medium text-gray-900">
          Timeline
        </h2>

        <div className="mt-6 flow-root">
          <ul className="-mb-8">
            {agent.attributes.timelines.data.length !== 0 &&
              timelines.map((item, itemIdx) => (
                <li key={item.id}>
                  <div className="relative pb-8">
                    {itemIdx !== timelines.length - 1 ? (
                      <span
                        className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200"
                        aria-hidden="true"
                      />
                    ) : null}
                    <div className="relative flex space-x-3">
                      <div>
                        <span
                          className={classNames(
                            eventTypes[item.attributes["type"]].bgColorClass,
                            "h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                          )}
                        >
                          {item.attributes.type === "tookLoan" ? (
                            <MinusCircleIcon
                              className="w-5 h-5 text-white"
                              aria-hidden="true"
                            />
                          ) : (
                            <PlusCircleIcon
                              className="w-5 h-5 text-white"
                              aria-hidden="true"
                            />
                          )}
                        </span>
                      </div>
                      <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                        <div>
                          <p className="text-sm text-gray-500">
                            {item.attributes.message}{" "}
                            <span className="font-medium text-gray-900">
                              {item.attributes.amount} ETB
                            </span>
                          </p>
                        </div>
                        <div className="text-right text-sm whitespace-nowrap text-gray-500">
                          <time dateTime={item.datetime}>
                            {formatDate(item.attributes.createdAt)}
                          </time>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            {agent.attributes.timelines.data.length === 0 && (
              <p className="mb-8 text-sm text-gray-500">
                No timelines to show yet
              </p>
            )}
          </ul>
        </div>
      </div>
    </section>
  );
}
